module.exports = __webpack_public_path__ + "static/GimletXRay-VF-4d272763bce9fc6e6350b84457a6751c.woff2";